import type { SVGProps } from 'react'

export const CloudLoadingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_2061_4362)">
      <g clipPath="url(#clip1_2061_4362)">
        <g clipPath="url(#clip2_2061_4362)">
          <path
            d="M8 12.0026H4.438C2.72333 12 1.33333 10.662 1.33333 9.0113C1.33333 7.3613 2.72333 6.0233 4.438 6.0233C4.7 4.84863 5.63399 3.88996 6.88799 3.50796C8.14133 3.12663 9.52533 3.3793 10.5173 4.17463C11.5093 4.96796 11.9587 6.1793 11.6973 7.35396H12.3573C13.2773 7.35396 14.0727 7.89596 14.444 8.68063"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
    <path d="M12.6667 11V10.1666" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.8463 11.4863L14.4436 10.889" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.3333 12.6666H15.1667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.8463 13.8473L14.4436 14.4445" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.6667 14.3334V15.1667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.4878 13.8473L10.8906 14.4445" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11 12.6666H10.1667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.4878 11.4863L10.8906 10.889" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
